import React, { useImperativeHandle, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { DialogTitle, IconButton, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Close } from '@material-ui/icons';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const XRContentDialog = React.forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(null);

    const close = () => {
        setOpen(false);
    };

    useImperativeHandle(ref, () => ({
        openXRPage(id) {
            setOpen(true);
            setCurrentPage(`https://www.platformadigitaliada.ro/xr/${id}/view`);
        },
    }));

    return (
        <Dialog open={open} onClose={() => {
            setOpen(false);
        }} fullScreen={true}>
            <DialogContent style={{ overflow: 'auto' }}>
                <IconButton aria-label='close' onClick={close} style={{ position: 'absolute', right: '1rem' }}
                            color={'secondary'}>
                    <Close />
                </IconButton>
                <iframe width={'400px'} height={'400px'} src={currentPage} />
            </DialogContent>
        </Dialog>
    );

});

export default XRContentDialog;